import Store from 'store'
import _isArray from 'lodash/isArray'
import StorageKeys from './storage-keys'

export function fill_utm_form (form, defaultValues = {}) {
  [
    ['utm_source', StorageKeys.UTM.SOURCE],
    ['utm_medium', StorageKeys.UTM.MEDIUM],
    ['utm_campaign', StorageKeys.UTM.CAMPAIGN],
    ['utm_content', StorageKeys.UTM.CONTENT],
    ['utm_term', StorageKeys.UTM.TERM]
  ].forEach(item => {
    const [field, storageKey] = item
    const legacy = Store.get('agile_' + field)

    let value = legacy || Store.get(storageKey)

    if (_isArray(value) && value.length > 0) {
      value = value[0]
    }

    if (!value && (typeof defaultValues[field] !== 'undefined')) {
      value = defaultValues[field]
    }

    if (value) {
      form[field] = value
    }
  })
}
